import { to } from "await-to-js";
import { createI18n } from "vue-i18n";
import { useJurisdictionSwitch } from "@dutypay/front-end-design-system/src/composables";
import { interceptor } from "@dutypay/front-end-design-system/src/utilities/index.js";
import "@dutypay/front-end-design-system/src/locales/numeralLocales";
import { cloneDeep } from "lodash";

const { loadJurisdiction, setDayJSLocale, setNumeralLocale, setDocumentLanguage, setJurisdictionInLocalStorage } =
    useJurisdictionSwitch();

const jurisdiction = await loadJurisdiction();
setDayJSLocale(jurisdiction);
setNumeralLocale(jurisdiction);
setDocumentLanguage(jurisdiction);
setJurisdictionInLocalStorage(jurisdiction);
const locale = jurisdiction.i18n;

async function remoteFetchTranslations() {
    let messages = {};
    let translationValues, error;
    [error, translationValues] = await to(
        interceptor.get(
            `${process.env.VUE_APP_API_DUTYPAY}/api/v0/translations/${process.env.VUE_APP_APPLICATION_VARIABLE}/${locale}`,
        ),
    );
    if (error) {
        messages[locale] = {};
    } else {
        messages[locale] = cloneDeep(translationValues.data);
    }
    return messages;
}

export const i18n = createI18n({
    globalInjection: true,
    useScope: "global",
    legacy: false,
    locale: locale,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en-US",
    messages: await remoteFetchTranslations(),
    fallbackWarn: false,
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    missingWarn: false,
});
